import React from 'react';

import { Loader } from '@eika/loader';

import { AmountAndCurrencyFieldMobile } from '../amount-and-currency-field/AmountAndCurrencyField';
import ConvertRateInfoLine from '../convert-rate-info-line/ConvertRateInfoLine';
import ExchangeRateOneToOneInfo from '../exchange-rate-one-to-one-info/ExchangeRateOneToOneInfo';
import SwapButton from '../swap-button/SwapButton';
import { CalculatorFieldName, VisaFxSimpleCalculatorProps } from '../types';

import './VisaFxSimpleCalculatorMobile.scss';

const VisaFxSimpleCalculatorMobile = ({
    calculator,
    loadingRate,
    onChangeAmountFrom,
    onChangeAmountTo,
    onClickSelectCurrency,
    setFocusedField,
    swapCurrencies,
    onClickMoreInfo,
    currencyOnRightSide,
    dictionary,
    piwik,
}: VisaFxSimpleCalculatorProps) => (
    <section>
        <ExchangeRateOneToOneInfo calculator={calculator} />
        <article className="calculator-with-swap-button">
            <div className="from-to-currency-container">
                <AmountAndCurrencyFieldMobile
                    calculator={calculator}
                    onChangeAmount={onChangeAmountFrom}
                    onClickSelectCurrency={onClickSelectCurrency}
                    focusedField={CalculatorFieldName.FROM}
                    setFocusedField={setFocusedField}
                    currencyOnRightSide={currencyOnRightSide}
                    piwik={piwik}
                />
                <AmountAndCurrencyFieldMobile
                    calculator={calculator}
                    onChangeAmount={onChangeAmountTo}
                    onClickSelectCurrency={onClickSelectCurrency}
                    focusedField={CalculatorFieldName.TO}
                    setFocusedField={setFocusedField}
                    currencyOnRightSide={currencyOnRightSide}
                    piwik={piwik}
                />
            </div>
            <div className="swap-button">
                {loadingRate ? (
                    <Loader className="rate-loader" mini />
                ) : (
                    <SwapButton swapCurrencies={swapCurrencies} piwik={piwik} />
                )}
            </div>
        </article>
        <footer className="footer-info">
            <ConvertRateInfoLine onClickMoreInfo={onClickMoreInfo} dictionary={dictionary} piwik={piwik} />
        </footer>
    </section>
);

export default VisaFxSimpleCalculatorMobile;
